import { createRouter, Navigate, RouterProvider } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import viewer from '@/shared/utils/viewer';
import { handleMessageEvent } from '@/shared/launcher';
import { initGA } from 'vs-gs';
import { initLog } from 'visang-tracker';
import { useLoginStore } from '@/shared/lib/store';
import Error404 from '@/shared/publish/Homework/Error404';
import { useEffect } from 'react';

const DefaultNotFoundComponent = () => {
    const studentYn = useLoginStore((state) => state.loginInfo.studentYn);

    if (studentYn !== 'Y') {
        return <Navigate to="/create" replace />;
    }

    return <Error404 />;
};

const router = createRouter({
    routeTree,
    defaultNotFoundComponent: DefaultNotFoundComponent,
});
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            // staleTime: 100,
        },
    },
});

// ✅ URL에 `$`가 포함되어 있으면 `#`로 변경 후 새로고침 >> 평가 진입을 위한 함수
if (window.location.href.includes('$') && window.location.href.includes('eval')) {
    const newUrl = window.location.href.replace(/\$/g, '#');
    window.location.replace(newUrl);
}

const App = () => {
    const deploy = import.meta.env.VITE_DEPLOY;

    useEffect(() => {
        viewer.initViewerScript(() => {
            viewer.initEditorScript();
        });
    }, []);

    initLog({
        logBaseUrl: import.meta.env.VITE_AIDT_LOG_API,
    });
    if (deploy === 'prod') initGA('스마트 문제은행', 'G-E5Q6XYNSRL');
    return (
        <QueryClientProvider client={queryClient}>
            {/* <GlobalLoading /> */}
            <RouterProvider router={router} />
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

window.addEventListener('message', handleMessageEvent);

export default App;
